import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { DropdownList } from 'react-widgets';
import CheckBox from '../../../components/check-box';
import ErrorMessage from '../../../components/text/ErrorMessage';
import { Customer, Lead, WorkExperience } from '../../../core/api/models';
import 'react-widgets/dist/css/react-widgets.css';
import DateInput from '../../../components/form-group/date-input';
import { useHasPermission, AppPermissions, TypeOfBusiness, CompanyPosition, Industry, Designation } from '../../../core';
import { useDataLoader } from 'react-remote-data-hooks';
import api from '../../../api';

const EmploymentType = [{ name: 'Full Time' }, { name: 'Part Time' }];


const Year: any[] | undefined = [];
for (
  let index = new Date().getFullYear() - 50;
  index < new Date().getFullYear() + 1;
  index++
) {
  Year.push({ label: index, value: index });
}

const WorkExperienceForm: React.FunctionComponent<{
  onSubmit: (experience: any) => void;
  onReset: () => void;
  customerDetails?: Customer;
  leadDetails?: Lead;
}> = (props) => {
  const {
    control,
    handleSubmit,
    errors,
    reset,
    watch,
    setValue,
  } = useForm<WorkExperience>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
  });

  const canUpdateCustomerExperiences = useHasPermission(
    AppPermissions.UpdateCustomerExperiences
  );

  const currentWorkDetails = props.leadDetails?.customer?.workDetails
    ? props.leadDetails?.customer?.workDetails[
        props.leadDetails?.customer?.workDetails.length - 1
      ]
    : null;

  const isCurrentEmployer: boolean = (watch(
    'isCurrentEmployer'
  ) as unknown) as boolean;

  const startDate: Date = (watch('startDate') as unknown) as Date;

  const endDate: Date = (watch('startDate') as unknown) as Date;

  const { data:businessType } = useDataLoader<Industry[]>(() =>
  api.industry.loadAllIndustry()
  );

  
  const { data:companyPositionData } = useDataLoader<Designation[]>(() =>
  api.designation.loadAllDesignation()
  );
  

  return props.leadDetails ? (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div>
        <div className="form-group font-weight-semibold mb-3">
          <label htmlFor="" className="font-sm text-uppercase">
            Job Title
          </label>
          <Controller
            control={control}
            // rules={{
              // required: true,
              // validate: (value) => {
                // return !!value.trim();
              // },
            // }}
            name="jobTitle"
            defaultValue={currentWorkDetails?.jobTitle}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Job Title"
                name={name}
                value={value}
                onChange={onChange}
                id="jobTitle"
                // ref={(input) => input && input.focus()}
                disabled={!canUpdateCustomerExperiences}
              />
            )}
          />
          {errors.jobTitle && (
            <ErrorMessage>Job Title is required</ErrorMessage>
          )}
        </div>
        <div className="form-group font-weight-semibold mb-3">
          <label htmlFor="" className="font-sm text-uppercase">
            Employment Type
          </label>
          <Controller
            control={control}
            // rules={{ required: true }}
            name="employmentType"
            defaultValue={currentWorkDetails?.employmentType}
            render={({ onChange, value }) => (
              <DropdownList
                value={value}
                data={EmploymentType}
                defaultValue={value}
                textField={'name'}
                valueField={'name'}
                placeholder={'Select Employment Type'}
                onChange={(val) => {
                  onChange(val.name);
                }}
                disabled={!canUpdateCustomerExperiences}
              />
            )}
          />
          {errors.employmentType && (
            <ErrorMessage>Employment Type is required</ErrorMessage>
          )}
        </div>
        <div className="form-group font-weight-semibold mb-3">
          <label htmlFor="" className="font-sm text-uppercase">
            Company<span className="text-danger">*</span>
          </label>
          <Controller
            control={control}
            rules={{
              required: true,
              validate: (value) => {
                return !!value.trim();
              },
            }}
            name="companyName"
            defaultValue={currentWorkDetails?.companyName}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Company"
                name={name}
                value={value}
                onChange={onChange}
                id="companyName"
                disabled={!canUpdateCustomerExperiences}
              />
            )}
          />
          {errors.companyName && (
            <ErrorMessage>Company is required</ErrorMessage>
          )}
        </div>
        <div className="form-group font-weight-semibold mb-3">
          <label htmlFor="" className="font-sm text-uppercase">
          Position
          </label>
          <Controller
            control={control}
            // rules={{ required: true }}
            name="companyPosition"
            defaultValue={currentWorkDetails?.companyPosition}
            render={({ onChange, value }) => (
              <DropdownList
                value={value}
                data={companyPositionData}
                defaultValue={value}
                textField={'name'}
                valueField={'name'}
                placeholder={'Select Position'}
                onChange={(val) => {
                  onChange(val.name);
                }}
                disabled={!canUpdateCustomerExperiences}
              />
            )}
          />
          {errors.businessType && (
            <ErrorMessage>Type Of Business is required</ErrorMessage>
          )}
        </div>
        <div className="form-group font-weight-semibold mb-3">
          <label htmlFor="" className="font-sm text-uppercase">
            Type Of Business
          </label>
          <Controller
            control={control}
            // rules={{ required: true }}
            name="businessType"
            defaultValue={currentWorkDetails?.businessType}
            render={({ onChange, value }) => (
              <DropdownList
                value={value}
                data={businessType}
                defaultValue={value}
                textField={'name'}
                valueField={'name'}
                placeholder={'Select Type Of Business'}
                onChange={(val) => {
                  onChange(val.name);
                }}
                disabled={!canUpdateCustomerExperiences}
              />
            )}
          />
          {errors.businessType && (
            <ErrorMessage>Type Of Business is required</ErrorMessage>
          )}
        </div>
        <div className="form-group font-weight-semibold mb-3">
          <label htmlFor="" className="font-sm text-uppercase">
            Location
          </label>
          <Controller
            control={control}
            // rules={{ required: true }}
            name="location"
            defaultValue={currentWorkDetails?.location}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Location"
                name={name}
                value={value}
                onChange={onChange}
                id="location"
                disabled={!canUpdateCustomerExperiences}
              />
            )}
          />
          {errors.location && <ErrorMessage>Location is required</ErrorMessage>}
        </div>
        <div className="form-group font-weight-semibold mb-3 py-1">
          <Controller
            control={control}
            name="isCurrentEmployer"
            // rules={{ required: true }}
            defaultValue={currentWorkDetails?.isCurrentEmployer}
            render={({ onChange, value }) => (
              <CheckBox
                checked={value}
                id={'isCurrentEmployer'}
                onChange={onChange}
                label={'I am currently working in this role'}
                disabled={!canUpdateCustomerExperiences}
              />
            )}
          />
        </div>
        <div className="row gutter-5">
          <div className="col-sm-6 col-12">
            <div className="form-group font-weight-semibold mb-2">
              <label htmlFor="" className="font-sm text-uppercase">
                Start Date
              </label>
              <div className="row gutter-5">
                <div className="col-12">
                  <Controller
                    control={control}
                    name="startDate"
                    defaultValue={currentWorkDetails?.startDate}
                    render={({ onChange, value, name }) => (
                      <DateInput
                        default={value}
                        placeholder={'mm/yyyy'}
                        onChange={(val) => {
                          onChange(val);
                          setValue('endDate', '');
                        }}
                        maxDate={new Date()}
                        dateFormat="MMMM  yyyy"
                        showMonthYearPicker={true}
                        showTwoColumnMonthYearPicker={true}
                        showFullMonthYearPicker={true}
                        disabled={!canUpdateCustomerExperiences}
                      />
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
          {!isCurrentEmployer && (
            <div className="col-sm-6 col-12">
              <div className="form-group font-weight-semibold mb-2">
                <label htmlFor="" className="font-sm text-uppercase">
                  End Date
                </label>
                <div className="row gutter-5">
                  <div className="col-12">
                    <Controller
                      control={control}
                      name="endDate"
                      defaultValue={currentWorkDetails?.endDate}
                      render={({ onChange, value, name }) => (
                        <DateInput
                          default={value}
                          placeholder={'mm/yyyy'}
                          onChange={onChange}
                          minDate={startDate}
                          maxDate={new Date()}
                          dateFormat="MMMM  yyyy"
                          showMonthYearPicker={true}
                          showTwoColumnMonthYearPicker={true}
                          showFullMonthYearPicker={true}
                          disabled={!canUpdateCustomerExperiences}
                        />
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            type="button"
            disabled={
              !canUpdateCustomerExperiences || !props?.leadDetails?.isEditable
            }
            onClick={() => {
              reset({
                jobTitle: '',
                employmentType: '',
                companyName: '',
                businessType: '',
                location: '',
                isCurrentEmployer: '',
                startDate: '',
                endDate: '',
                companyPosition: '',
              });
              props.onReset();
            }}
            title={
              !canUpdateCustomerExperiences || !props?.leadDetails?.isEditable
                ? 'No permisssion to update Work Experience'
                : ''
            }
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
          >
            Reset
          </button>
          <button
            disabled={
              !canUpdateCustomerExperiences || !props?.leadDetails?.isEditable
            }
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4"
            title={
              !canUpdateCustomerExperiences || !props?.leadDetails?.isEditable
                ? 'No permisssion to update Work Experience'
                : ''
            }
          >
            Save
          </button>
        </div>
      </div>
    </form>
  ) : (
    <></>
  );
};

export default WorkExperienceForm;
